import { OrderOptimizerListItemRoute } from "../../../../../common/services/order-optimizer/list/order-optimizer-list";
import OrderOptimizerRoadRouteParams, {
  OrderOptimizerRoadRouteParamsWaypoints,
} from "../../../../../common/services/order-optimizer/road-route/order-optimizer-road-route-params";
import {
  OrderOptimizerTaxiListingItem,
  OrderOptimizerTaxiListingItemRoute,
} from "./types/order-optimizer-taxi-listing-item";

const createWaypoint = (
  address: OrderOptimizerListItemRoute,
): OrderOptimizerTaxiListingItemRoute => {
  return {
    lat: address.lat,
    lon: address.lon,
    orderHumanId: address.orderHumanId,
  };
};

const createWaypoints = (
  responseTransportingOrderOptimizations: OrderOptimizerTaxiListingItem,
): OrderOptimizerTaxiListingItemRoute[][] => {
  const splitWaypoints: OrderOptimizerListItemRoute[][] = [];

  responseTransportingOrderOptimizations.orders.forEach((order) => {
    splitWaypoints.push(
      responseTransportingOrderOptimizations.route.filter(
        (point) => point.orderHumanId === order.humanId,
      ),
    );
  });

  return splitWaypoints.map((route) => route.map(createWaypoint));
};

const createSearchRoutingCoordinate = (
  waypoint: OrderOptimizerTaxiListingItemRoute,
): OrderOptimizerRoadRouteParamsWaypoints => {
  return {
    lat: waypoint.lat,
    lon: waypoint.lon,
  };
};

const createSearchRoutingRequest = (
  waypoints: OrderOptimizerTaxiListingItemRoute[],
): OrderOptimizerRoadRouteParams => {
  const request: OrderOptimizerRoadRouteParams = {
    waypoints: waypoints.map(createSearchRoutingCoordinate),
  };

  return request;
};

const orderOptimizerTaxiDetailsWaypointFactory = {
  createWaypoints,
  createSearchRoutingRequest,
};

export default orderOptimizerTaxiDetailsWaypointFactory;
